import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/ArtistBadge.svg'

export const IconArtistBadge = IconSVG as IconComponent
